import { useState, useEffect } from 'react';

const useSnackbar = ({ action }) => {
  const [snackList, setSnackList] = useState([]);
  const [incrementalId, setIncrementalId] = useState(0);

  const onClose = id => {
    const updatedList = snackList.filter(item => item.id !== id);
    setSnackList(updatedList);
  };

  const onAddAction = newAction => {
    if (!newAction?.action) return;

    // Se verifica si existe una acción similar:
    if (newAction.preventDuplicateActions) {
      const isDuplicated = snackList.some(item => item.action === newAction.action && item.result === newAction.result);
      // No se agregan acciones duplicadas:
      if (isDuplicated) return;
    }

    const incrementedId = incrementalId + 1;
    newAction.id = incrementedId;

    // Si preventStacking está activado se evita apilar los snackbars:
    if (newAction.preventStacking) {
      setSnackList([newAction]);
    } else {
      // Se apilan los snackbars:
      setSnackList(prevList => [...prevList, newAction]);
    }
    setIncrementalId(incrementedId);
  };

  useEffect(() => {
    onAddAction(action);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  return {
    list: snackList,
    onClose
  };
};

export default useSnackbar;
